import { getSupabase } from "@/lib/supabase-lazy";

export interface HomeModuleRow {
  module_key: string;
  access_type: string;
  sort_order: number | null;
}

export interface PricingContentRow {
  lang: string;
  section: string;
  content: unknown;
}

export interface HomeSsrData {
  modules: HomeModuleRow[];
  pricingRows: PricingContentRow[];
}

/**
 * Datos que alimentan la landing. Se cargan desde el `loader` de la ruta "/"
 * para que el HTML servido incluya ya el contenido (SSR), no solo el hero.
 */
export async function fetchHomeSsrData(): Promise<HomeSsrData> {
  const supabase = await getSupabase();
  const [modulesRes, pricingRes] = await Promise.all([
    supabase
      .from("module_content")
      .select("module_key, access_type, sort_order")
      .eq("lang", "es")
      .neq("access_type", "hidden")
      .neq("module_key", "basics")
      .neq("module_key", "blindaje_legal")
      .order("sort_order"),
    supabase.from("pricing_content").select("lang, section, content"),
  ]);

  return {
    modules: (modulesRes.data ?? []) as HomeModuleRow[],
    pricingRows: (pricingRes.data ?? []) as PricingContentRow[],
  };
}
